<template>
  <v-container class="mt-4 px-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <!--Botones control de la vista-->
          <v-card-title primary-title>

            <v-icon
              small
              class="mx-2"
              color="primary"
              @click="dialogAyuda = true"
            >
              mdi-help-circle
            </v-icon>
            Panel de calificaciones

            <v-radio-group v-model="escuela" row class="ml-2">
              <v-radio label="Fast" :value="2"></v-radio>
              <v-radio label="Inbi" :value="1"></v-radio>
            </v-radio-group>

            <v-spacer></v-spacer>

            <v-btn class="mr-2" small dark color="green" @click="exportExcel(filterAlumnos, 'PUNTOS_ALUMNOS')" :disabled="loadingCalificaciones" tile>
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn color="orange" dark class="mr-2"  @click="confirmarCargaMasiva()" small :disabled="loadingCalificaciones || !filterAlumnos.length" tile>
              <v-icon left small>mdi-upload-multiple</v-icon>
              Carga masiva
            </v-btn>

            <v-btn color="primary" dark class="text-capitalize" @click="consultarCalificaciones({ force: true })" small :loading="loadingCalificaciones" :disabled="!ciclo || loadingCalificaciones" tile>
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-progress-linear
            v-if="loadingCalificaciones"
            indeterminate
            color="primary"
            height="3"
          ></v-progress-linear>

          <v-card-text>
            <v-row justify="space-between">
              <v-col cols="12" md="4" lg="3" class="pb-0">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  :loading="loadingCiclos || loadingCalificaciones"
                  :disabled="loadingCiclos"
                  label="Selecciona ciclo actual"
                  persistent-hint
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" lg="3" class="pb-0">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="filtroRI"
                  :items="['ES RI', 'NO RI']"
                  label="Filtro RI"
                  persistent-hint
                  hide-details
                >
                </v-autocomplete>
              </v-col>

              <!-- Filtro por plantel -->
              <v-col cols="12" md="4" lg="3" class="pb-0">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="filtroPlantel"
                  :items="planteles"
                  label="Filtro Plantel"
                  persistent-hint
                  hide-details
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" lg="3" class="pb-0">
                <v-text-field
                  label="Buscar"
                  v-model="searchInput"
                  dense
                  filled
                  append-icon="mdi-magnify"
                  clearable
                  :disabled="loadingCalificaciones && !alumnos.length"
                  :hint="(searchInput || '') !== search ? 'Buscando...' : ''"
                  persistent-hint
                  :hide-details="(searchInput || '') === search"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-radio-group v-model="option" row hide-details>
                  <v-radio label="Todos" :value="1"></v-radio>
                  <v-radio label="Reprobados" :value="2"></v-radio>
                  <v-radio label="Extraordinario y Primera" :value="3"></v-radio>
                  <v-radio label="Solo aprobados" :value="4"></v-radio>
                  <v-radio label="Sin Kardex" :value="5"></v-radio>
                  <v-radio label="Sin Kardex Reprobado" :value="6"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-icon small color="orange">mdi-account</v-icon> Alumnos: {{ resumenAlumnos.total }}<br/>
                <v-icon small color="green" >mdi-access-point-check</v-icon> Con Conexión: {{ resumenAlumnos.conConexion }}<br/>
                <v-icon small color="red"   >mdi-access-point-off</v-icon> Sin Conexión: {{ resumenAlumnos.sinConexion }}<br/>
                <v-icon small color="primary" >mdi-account-group</v-icon> RI: {{ resumenAlumnos.ri }}<br/>
                <v-icon small color="red"     >mdi-account-group</v-icon> NO RI: {{ resumenAlumnos.noRi }}<br/>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filterAlumnos"
              class="elevation-0 puntos-alumnos-tabla"
              :search="search"
              :loading="loadingCalificaciones"
              loading-text="Actualizando calificaciones..."
              no-data-text="Selecciona un ciclo para consultar calificaciones"
              dense
            >
              <template v-slot:item.asistencias="{ item }">
                {{ item.asistencias + " de " + item.total_dias_laborales }}
              </template>

              <template v-slot:item.examenes="{ item }">
                {{ item.examenes + " de " + item.num_examenes }}
              </template>

              <template v-slot:item.ejercicios="{ item }">
                {{ item.ejercicios + " de " + item.num_ejercicios }}
              </template>

              <template v-slot:item.total="{ item }">
                <v-chip label small :color="item.total < 70 ? 'red' : 'green'" dark>
                  {{ item.total }}
                </v-chip>
              </template>

              <template v-slot:item.estado_comentario="{ item }">
                <v-chip small label color="orange" dark v-if="item.estado_comentario == 0">Posible Comentario</v-chip>

                <v-chip small label color="green" dark v-if="item.estado_comentario == 1">Aprobado</v-chip>

                <v-chip small label color="black" dark v-if="item.estado_comentario == 2">Reprobado</v-chip>

                <v-chip small label color="secondary" dark v-if="item.estado_comentario == 3">Examen Extraordinario</v-chip>

                <v-chip small label color="black" dark v-if="item.estado_comentario == 4">Pase por comentario</v-chip>

                <v-chip small label color="black" dark v-if="item.estado_comentario == 5">Reubicacion</v-chip>
              </template>

              <template v-slot:item.ultimo_movimiento="{ item }">
                <span v-if="item.dias_desde_ultimo_movimiento >= 7" class="red--text">{{item.ultimo_movimiento}}</span>
                <span v-else class="black--text">{{ item.ultimo_movimiento }} </span>
              </template>

              <template v-slot:item.extra="{ item }">
                <v-chip small :color="item.extra < 70 ? 'red' : 'green'" dark v-if="item.extra">
                  {{ item.extra }}
                </v-chip>
              </template>

              <template v-slot:item.posibilidad="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip small v-bind="attrs" v-on="on">
                      {{
                        parseFloat(item.total) + parseFloat(item.pts_finales)
                      }}
                    </v-chip>
                  </template>
                  <span
                    >Esta es la calificación que el alumno podría obtener si
                    contesta todos sus ejercicios o exámenes faltantes.</span
                  >
                </v-tooltip>
              </template>

              <template v-slot:item.ver="{ item }">
                <div
                  class="puntos-alumnos-acciones d-flex align-center justify-center flex-nowrap"
                  :class="{ 'puntos-alumnos-acciones--con-reubicacion': puedeActivarExamenReubicacion }"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="green"
                        dark
                        small
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="buscarCalificacion(item)"
                      >
                        <v-icon small>mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver calificaciones</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="orange"
                        dark
                        small
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="subirCalifiacionAlumno(item)"
                      >
                        <v-icon small>mdi-arrow-up-bold</v-icon>
                      </v-btn>
                    </template>
                    <span>Subir calificación</span>
                  </v-tooltip>

                  <v-tooltip v-if="puedeActivarExamenReubicacion" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        small
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="activarExamenReubicacion(item)"
                      >
                        <v-icon small>mdi-map-marker-path</v-icon>
                      </v-btn>
                    </template>
                    <span>Activar examen de reubicación</span>
                  </v-tooltip>
                </div>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de carga -->
    <v-dialog
      v-if="verCalificaciones"
      v-model="dialogAlumno"
      persistent
      max-width="800"
    >
      <v-card>
        <v-card-title class="text-h5"> Calificaciones </v-card-title>
        <v-card-text>
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="basil"
            grow
          >
            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- Asistencias -->
            <v-tab-item>
              <v-card color="basil" flat>
                <v-card-title primary-title>
                  {{ calificaciones.asistencias.pts_total_asistencia }} pts de
                  {{ calificaciones.asistencias.limite }} pts
                  <v-progress-linear
                    color="orange"
                    height="25"
                    style="border-radius: 50px"
                    :value="
                      (
                        (calificaciones.asistencias.pts_total_asistencia /
                          calificaciones.asistencias.limite) *
                        100
                      ).toFixed(1)
                    "
                  >
                    <template v-slot:default="{ value }">
                      <strong
                        >{{
                          (
                            (calificaciones.asistencias.pts_total_asistencia /
                              calificaciones.asistencias.limite) *
                            100
                          ).toFixed(1)
                        }}%</strong
                      >
                    </template>
                  </v-progress-linear>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    width="100%"
                    :headers="headersAsistencias"
                    :items="calificaciones.asistencias.desgloce"
                    :items-per-page="calificaciones.asistencias.desgloce.length"
                    class="elevation-0"
                    :mobile-breakpoint="100"
                    hide-default-footer
                    fixed-header
                    dense
                    height="400"
                    @click:row="onClickRow"
                  >
                    <template v-slot:item.valor_text="{ item }">
                      <v-chip small rounded :color="item.color">{{
                        item.valor_text
                      }}</v-chip>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Ejercicios -->
            <v-tab-item>
              <v-card color="basil" flat>
                <v-card-title primary-title>
                  {{ calificaciones.ejercicios.pts_total_ejercicios }} pts de
                  {{ calificaciones.ejercicios.limite }} pts

                  <v-progress-linear
                    color="orange"
                    height="25"
                    style="border-radius: 50px"
                    :value="
                      (
                        (calificaciones.ejercicios.pts_total_ejercicios /
                          calificaciones.ejercicios.limite) *
                        100
                      ).toFixed(1)
                    "
                  >
                    <template v-slot:default="{ value }">
                      <strong
                        >{{
                          (
                            (calificaciones.ejercicios.pts_total_ejercicios /
                              calificaciones.ejercicios.limite) *
                            100
                          ).toFixed(1)
                        }}%</strong
                      >
                    </template>
                  </v-progress-linear>
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    width="100%"
                    :headers="headersDetalleEvaluaciones"
                    :items="calificaciones.ejercicios.desgloce"
                    :items-per-page="calificaciones.ejercicios.desgloce.length"
                    class="elevation-0"
                    :mobile-breakpoint="100"
                    hide-default-footer
                    fixed-header
                    dense
                    height="400"
                  >
                    <template v-slot:item.valor_text="{ item }">
                      <v-chip small rounded :color="item.color">{{
                        item.valor_text
                      }}</v-chip>
                    </template>

                    <!-- Slot de la columna acciones -->
                    <template
                    v-if="puedeEliminarCalificaciones"
                    v-slot:item.acciones="{ item }">
                      <v-btn
                        small
                        color="primary"
                        @click="abrirDialog( item.id_evaluacion, item.id_alumno, item.id_grupo, item )"
                      >
                        <v-icon small left>mdi-eye</v-icon>
                        Ver
                      </v-btn>
                      <v-btn
                        small
                        color="red"
                        @click="eliminarEjercicio( item.id_evaluacion, item.id_alumno, item.id_grupo, item, 'ejercicio' )"
                        style="margin-left: 1rem;"
                      >
                        Borrar
                      </v-btn>

                    </template>

                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Examenes -->
            <v-tab-item>
              <v-card color="basil" flat>
                <v-card-title primary-title>
                  {{ calificaciones.examenes.pts_total_examenes }} pts de
                  {{ calificaciones.examenes.limite }} pts
                  <v-progress-linear
                    color="orange"
                    height="25"
                    style="border-radius: 50px"
                    :value="
                      (
                        (calificaciones.examenes.pts_total_examenes /
                          calificaciones.examenes.limite) *
                        100
                      ).toFixed(1)
                    "
                  >
                    <template v-slot:default="{ value }">
                      <strong
                        >{{
                          (
                            (calificaciones.examenes.pts_total_examenes /
                              calificaciones.examenes.limite) *
                            100
                          ).toFixed(1)
                        }}%</strong
                      >
                    </template>

                  </v-progress-linear>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    width="100%"
                    :headers="headersDetalleEvaluaciones"
                    :items="calificaciones.examenes.desgloce"
                    :items-per-page="calificaciones.examenes.desgloce.length"
                    class="elevation-0"
                    :mobile-breakpoint="100"
                    hide-default-footer
                  >
                    <template v-slot:item.valor_text="{ item }">
                      <v-chip small rounded :color="item.color">{{
                        item.valor_text
                      }}</v-chip>
                    </template>

                    <template
                    v-if="puedeEliminarCalificaciones"
                    v-slot:item.acciones="{ item }">
                      <v-btn
                        small
                        color="primary"
                        @click="abrirDialog( item.id_evaluacion, item.id_alumno, item.id_grupo, item )"
                      >
                        <v-icon small left>mdi-eye</v-icon>
                        Ver
                      </v-btn>
                      <v-btn
                        small
                        color="red"
                        @click="eliminarEjercicio( item.id_evaluacion, item.id_alumno, item.id_grupo, item, 'examen' )"
                        style="margin-left: 1rem;"
                      >
                        Borrar
                      </v-btn>

                    </template>

                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card color="basil" flat>
                <v-card-text align="center" class="text-center">
                  <v-progress-circular
                    align="center"
                    :rotate="90"
                    :size="220"
                    :width="25"
                    :value="calificaciones.calificacion_total"
                    color="pink"
                  >
                    <span class="text-h6"
                      >{{ calificaciones.calificacion_total }} pts de 100</span
                    >
                  </v-progress-circular>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogAlumno = false">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="dialogAlumno = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Ayuda -->
    <v-dialog
  v-model="dialogAyuda"
  persistent
  max-width="900"
>
  <v-card>

    <v-card-title class="text-h5">
      Ayuda — Documentación
    </v-card-title>

    <v-card-text>

      <div
        v-for="(video, index) in videosAyuda"
        :key="index"
        class="mb-6"
      >
        <h3 class="subtitle-1 font-weight-bold mb-2">
          {{ video.titulo }}
        </h3>

        <video
        v-if="video.url.includes('.mp4')"
          :src="video.url"
          controls
          controlslist="nodownload"
          style="width: 100%; border-radius: 12px;"
        ></video>

        <div v-if="video.url.includes('.pdf')">
          <embed type="application/pdf"
          :src="video.url"
          height="600" width="100%"></div>
      </div>

    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="dialogAyuda = false">
        Cerrar
      </v-btn>
    </v-card-actions>

  </v-card>
    </v-dialog>

    <!-- Dialog de Editar Asistencia -->
<v-dialog
  v-model="dialogEditarAsistencia"
  persistent
  max-width="500"
>
  <v-card>
    <v-card-title class="text-h5">
      Editar Asistencia
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Fecha"
            :value="asistenciaSeleccionada.fecha_formato"
            readonly
            filled
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="nuevoValorAsistencia"
            :items="opcionesValorAsistencia"
            item-text="text"
            item-value="value"
            label="Valor de Asistencia"
            filled
            dense
            required
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" text @click="cerrarDialogEditar">
        Cancelar
      </v-btn>
      <v-btn 
        color="green darken-1" 
        text 
        @click="guardarAsistencia"
        :loading="guardandoAsistencia"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <PreviewLeccion
    ref="previewLeccion"
    v-model="dialogPreview.status"
    :dialogPreview="dialogPreview"></PreviewLeccion>
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
  import axios from 'axios';
  import XLSX from "xlsx";

  import { mapGetters, mapActions } from "vuex";
  var moment = require("moment");
  moment.locale();

  // Componentes
  import Alerta from "@/components/alertas/Alerta.vue";
  import carga from "@/components/alertas/carga.vue";
  import PreviewLeccion from "@/components/riesgo/PreviewLeccion.vue"

  import validarErrores from "@/mixins/validarErrores";
  import funcionesExcel from "@/mixins/funcionesExcel";

export default {
  components: {
    Alerta,
    carga,
    PreviewLeccion
  },

  mixins: [validarErrores, funcionesExcel],

  data: () => ({
    // Alertas
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },

    respuestaAlerta: false,
    loader: true,
    cargar: false,
    loadingCiclos: false,
    loadingCalificaciones: false,
    searchInput: "",
    searchTimer: null,
    consultaCalificacionesToken: 0,
    cacheCalificaciones: {},
    cacheAlumnosRI: {},

    gruposAlumnos:[],
    horarios:null,
    cicloInf: 		null,
    planteles: [],
    filtroPlantel: null,  
    ciclos: [],
    ciclo: null,
    idciclo: 0,
    dialogAlumno: false,
    calificaciones: {},
    verCalificaciones: false,
    tab: null,
    items: ["Participaciones", "Ejercicios", "Exámenes", "Total"],

    cardsCalificaciones: [
      {
        text: "Participaciones",
        series: [0],
        chartOptions: null,
        icono: "mdi-account",
        clase: "avataresAsistencias",
      },
      {
        text: "Ejercicios",
        series: [0],
        chartOptions: null,
        icono: "mdi-file-document",
        clase: "avataresEjercicios",
      },
      {
        text: "Exámenes",
        series: [0],
        chartOptions: null,
        icono: "mdi-file-check",
        clase: "avataresExamenes",
      },
      {
        text: "Total",
        series: [0],
        chartOptions: null,
        icono: "mdi-chart-arc",
        clase: "avataresTotal",
      },
    ],

    headersAsistencias: [
      {
        text: "Fecha",
        value: "fecha_formato",
        class: "text-uppercase grey--text text-caption",
      },
      {
        text: "Valor",
        value: "valor_text",
        class: "text-uppercase grey--text text-caption text-center",
        align: "center",
      },
    ],

    headersEjercicios: [
      {
        text: "Lección",
        value: "session",
        class: "text-uppercase grey--text text-caption",
      },
      {
        text: "Calificación",
        value: "calificacion",
        class: "text-uppercase grey--text text-caption text-center",
        align: "center",
      },
      /*{
    text: "Acciones",
    value: "acciones",
    class: "text-uppercase grey--text text-caption text-center",
    align: "center",
  },*/
    ],

    loading: false,
    search: "",
    dialog: false,
    dialogDelete: false,
    dialogAyuda: false,
    videosAyuda: [
        {
          titulo: 'Revisar calificaciones',
          url: 'https://academicokpi.club/capacitacion-archivos/99721709-fdfb-40d6-9b4b-d50e642851f9.pdf'
        },
      ],
    headers: [
      { text: "Matricula"      , value: "matricula" },
      { text: "Es RI"          , value: "ri" },
      { text: "Alumno"         , value: "nombre" },
      { text: "Grupo"          , value: "grupo" },
      { text: "Total"          , value: "total" },
      { text: "Extraordinario" , value: "extra" },
      { text: "1era"           , value: "primera" },
      { text: "2da"            , value: "segunda" },
      { text: "Estado"         , value: "estado_comentario" },
      { text: "Pases en extra" , value: "pases_extra", width: "5%" },
      { text: "Ultima conexión", value: "ultimo_movimiento", width: "170px" },
      { text: "Acciones", value: "ver", align: "center", sortable: false, width: "1%" },
      // { text: "Asistencias", value: "asistencias" },
      // { text: "Examenes", value: "examenes" },
      // { text: "Actividades", value: "ejercicios" },
      // { text: "Pts por obtener", value: "pts_finales" },
      // { text: "Posible calif.", value: "posibilidad" },
    ],
    alumnos: [],
    escuela: 1,
    option: 1,
    usuariosEliminarCalificaciones: [31, 568, 334, 1, 2354,2910,568,1312],
    usuariosActivarExamenReubicacion: [334, 568, 1312, 2910],

    dialogPreview: {
      status: false
    },
    itemSeleccionado: { id_evaluacion: 0, id_alumno: 0, id_grupo: 0 },
    alumnosRI:[],
    filtroRI: null,


    dialogEditarAsistencia: false,
    asistenciaSeleccionada: {},
    nuevoValorAsistencia: null,
    guardandoAsistencia: false,
    opcionesValorAsistencia: [
      { text: 'Pendiente', value: 0 },
      { text: 'Con participación', value: 1 },
      { text: 'Sin participación', value: 2 },
    ],

  }),

  watch: {
    async ciclo() {
      if (!this.ciclo) {
        this.alumnos = [];
        this.planteles = [];
        this.filtroPlantel = null;
        return;
      }

      if (this.ciclo) {
        this.filtroPlantel = null;
        await this.consultarCalificaciones();
      }
    },

    async escuela(){
      if (this.ciclo && this.escuela) {
        this.filtroPlantel = null;
        await this.consultarCalificaciones();
      }
    },

    searchInput(value) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.search = value || "";
      }, 300);
    }
  },

  computed: {
    ...mapGetters("login", [
      "getdatosUsuarioERPERP",
      "getLogeado",
      "getEscuela",
      "drawer2",
      "getEstatusLlamada",
      "getNuevosProspectos",
    ]),

    filterAlumnos() {

      let alumnos = this.alumnos


      if( this.filtroRI ){
        alumnos = alumnos.filter( el => el.ri == this.filtroRI )
      }

      if( this.filtroPlantel ){
        alumnos = alumnos.filter( el => el.plantel == this.filtroPlantel )
      }

      if (this.option == 2) {
        // Alumnos sin primera oportunidad
        return alumnos.filter((el) => {
          if (
            (el.primera < 70 && el.segunda < 70 && !el.grupo.match("CERTI")) ||
            (el.posibilidad < 80 && !el.grupo.match("CERTI"))
          ) {
            return true;
          } else {
          }
        });
      } else if( this.option == 3) {
        return alumnos.filter((el) => { return el.extra || el.total >= 69 })
      } else if( this.option == 4) {
        return alumnos.filter((el) => { return el.extra >= 70 || el.total >= 69 })
      } else if( this.option == 5) {
        // Alumnos sin primera oportunidad
        return alumnos.filter( el => !el.primera && !el.grupo.match('CERTI') && ( el.total >= 69 || el.extra >= 70 )  );
      } else if( this.option == 6) {
        // Alumnos sin primera oportunidad
        return alumnos.filter( el => !el.primera && !el.grupo.match('CERTI') && ( el.total < 69 && el.extra )  );
      }else{
        return alumnos;
      }
    },

    resumenAlumnos() {
      return this.alumnos.reduce((resumen, alumno) => {
        resumen.total++;

        if (alumno.ultimo_movimiento) {
          resumen.conConexion++;
        } else {
          resumen.sinConexion++;
        }

        if (alumno.ri == 'ES RI') {
          resumen.ri++;
        } else {
          resumen.noRi++;
        }

        return resumen;
      }, {
        total: 0,
        conConexion: 0,
        sinConexion: 0,
        ri: 0,
        noRi: 0,
      });
    },

    idsUsuarioCalificaciones() {
      const usuario = this.getdatosUsuarioERPERP || {};

      return [
        usuario.id_usuario,
        usuario.idusuarioerp,
        usuario.iderp,
      ].map((id) => Number(id)).filter((id) => !Number.isNaN(id));
    },

    puedeEliminarCalificaciones() {
      return this.idsUsuarioCalificaciones.some((id) => this.usuariosEliminarCalificaciones.includes(id));
    },

    puedeActivarExamenReubicacion() {
      return this.idsUsuarioCalificaciones.some((id) => this.usuariosActivarExamenReubicacion.includes(id));
    },

    headersDetalleEvaluaciones() {
      if (!this.puedeEliminarCalificaciones) {
        return this.headersEjercicios;
      }

      return [
        ...this.headersEjercicios,
        {
          text: "Acciones",
          value: "acciones",
          class: "text-uppercase grey--text text-caption text-center",
          align: "center",
        },
      ];
    },
  },

  async created() {
    // await this.getDatosAlumnosRI()
    await this.initialize()
  },

  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },

  methods: {

    getIdCicloConsulta() {
      if (!this.ciclo) return null;
      return this.escuela == 1 ? this.ciclo.id_ciclo : this.ciclo.id_ciclo_relacionado;
    },

    getCacheKeyCalificaciones(idCiclo) {
      const usuario = this.getdatosUsuarioERPERP || {};
      const planteles = (usuario.planteles || [])
        .map((plantel) => plantel.idplantel)
        .sort((a, b) => a - b)
        .join(',');

      return `${this.escuela}-${idCiclo}-${usuario.iderp}-${usuario.idpuesto}-${planteles}`;
    },

    aplicarCalificacionesCache(cache) {
      this.alumnos = cache.alumnos.map((alumno) => ({ ...alumno }));
      this.planteles = [...cache.planteles];
    },

    async getDatosAlumnosRI({ force = false, idCiclo = null } = {}) {
      const ciclo = idCiclo || this.getIdCicloConsulta();
      if (!ciclo) return [];

      const cacheKey = `${this.escuela}-${ciclo}`;

      if (!force && this.cacheAlumnosRI[cacheKey]) {
        this.alumnosRI = this.cacheAlumnosRI[cacheKey];
        return this.alumnosRI;
      }

      const response = await this.$http.get('inscripciones.list/' + ciclo);
      this.alumnosRI = response.data;
      this.$set(this.cacheAlumnosRI, cacheKey, response.data);

      return this.alumnosRI;
    },

    initialize() {
       this.getCiclos();
    },

    getCiclos() {
      this.loadingCiclos = true;
      this.cargar = true;
      this.ciclos = [];
      this.$http.get("kpi.ciclos.all?pasados=10&futuros=3").then((response) => {
        for (const i in response.data) {
          if (!(response.data[i].ciclo.search("FE") != -1)) {
            if (response.data[i].ciclo.search("CICLO") != -1) {
              this.ciclos.push(response.data[i]);
            }
          }
        }
      }).catch((error) => {
        this.validarError(error);
      }).finally(() => {
        this.loadingCiclos = false;
        this.cargar = false;
      });
    },

    async consultarCalificaciones(opciones = {}){
      if(this.ciclo && this.escuela){
        const force = Boolean(opciones.force);
        const idCiclo = this.getIdCicloConsulta();
        const cacheKey = this.getCacheKeyCalificaciones(idCiclo);

        if (!force && this.cacheCalificaciones[cacheKey]) {
          this.aplicarCalificacionesCache(this.cacheCalificaciones[cacheKey]);
          return;
        }

        const token = ++this.consultaCalificacionesToken;
        this.loadingCalificaciones = true;
        this.cargar = false;

        const payload = {
          idCiclo,
          escuela  : this.escuela,
          iderp    : this.getdatosUsuarioERPERP.iderp,
          idpuesto : this.getdatosUsuarioERPERP.idpuesto,
          planteles: this.getdatosUsuarioERPERP.planteles
        };

        try {
          const [ , response ] = await Promise.all([
            this.getDatosAlumnosRI({ force, idCiclo }),
            this.$http.post("riesgo.puntos", payload)
          ]);

          if (token !== this.consultaCalificacionesToken) return;

          let respuesta = response.data; //.filter( el => { return !el.grupo.match('KIDS') })
          // let respuesta = response.data.filter( el => { return el.grupo.match('SABATINO') })
          // let respuesta = response.data.filter( el => { return el.grupo.match('DOMINIC') })

          const { alumnos, planteles } = this.calcularCalificaciones2(respuesta);
          this.$set(this.cacheCalificaciones, cacheKey, {
            alumnos: alumnos.map((alumno) => ({ ...alumno })),
            planteles: [...planteles]
          });

          //this.calcularCalificaciones(respuesta);
        } catch (error) {
          if (token === this.consultaCalificacionesToken) {
            this.validarError(error);
          }
        } finally {
          if (token === this.consultaCalificacionesToken) {
            this.loadingCalificaciones = false;
            this.cargar = false;
          }
        }
      }
    },

    calcularCalificaciones2(value){
      const matriculasRI = new Set(
        this.alumnosRI
          .filter((alumno) => alumno.clase_row == 'alumno_ri')
          .map((alumno) => String(alumno.matricula))
      );
      const planteles = new Set();

      const alumnos = value.map((registro) => {
        const alumno = {
          ...registro,
          escuela: this.escuela,
          total: Number(registro.total || 0).toFixed(2),
          ri: matriculasRI.has(String(registro.matricula)) ? 'ES RI' : 'NO RI'
        };

        if (alumno.plantel) planteles.add(alumno.plantel);

        return alumno;
      });

      this.planteles = [...planteles];
      this.alumnos = alumnos;

      return {
        alumnos,
        planteles: this.planteles
      };
    },

    calcularCalificaciones(value) {
      var arrayCalificaciones = value;

      let alumnos = value.map((item) => {
        return [item.nombre, item];
      });
      var alumnosArray = new Map(alumnos); // Pares de clave y valor

      let unicos = [...alumnosArray.values()]; // Conversión a un array
      for (const i in unicos) {
        var sumaCalifEjercicio = 0;
        var cantEjercicio = 0;
        var sumaCalifExamen = 0;
        var cantExamen = 0;
        var sumaTotal = 0;
        var sumaAsistencia = 0;
        var cantAsistencia = 0;
        var sumaFalta = 0;
        var sumaRetardo = 0;
        var sumaJustificada = 0;
        var califExtra = "";
        for (const j in arrayCalificaciones) {
          if (unicos[i].id_alumno == arrayCalificaciones[j].id_alumno) {
            if (
              arrayCalificaciones[j].tipo_evaluacion == 1 &&
              arrayCalificaciones[j].idCategoriaEvaluacion == 1
            ) {
              sumaCalifEjercicio =
                sumaCalifEjercicio + arrayCalificaciones[j].calificacion;
              cantEjercicio = cantEjercicio + 1;
            } else {
              if (
                (arrayCalificaciones[j].tipo_evaluacion == 2 &&
                  arrayCalificaciones[j].idCategoriaEvaluacion == 1) ||
                (arrayCalificaciones[j].tipo_evaluacion == 2 &&
                  arrayCalificaciones[j].idCategoriaEvaluacion == 2)
              ) {
                sumaCalifExamen =
                  sumaCalifExamen + arrayCalificaciones[j].calificacion;
                cantExamen = cantExamen + 1;
              } else {
                califExtra = arrayCalificaciones[j].calificacion;
              }
            }
          }
        }

        // Haciendo el calculo para los puntos obtenidos de asistencias
        sumaAsistencia = unicos[i].asistencia;
        sumaFalta = unicos[i].falta;
        sumaRetardo = unicos[i].retardo;
        sumaJustificada = unicos[i].justificada;

        var ptsAsistencia =
          unicos[i].valor_asistencia / unicos[i].total_dias_laborales;
        var sumaTotalAsistencia =
          unicos[i].asistencia * ptsAsistencia +
          unicos[i].retardo * (ptsAsistencia / 2);

        // Calulando los puntos por ejercicios
        var divEjercico = sumaCalifEjercicio / unicos[i].num_ejercicios;
        var ptsEjercicio = unicos[i].valor_ejercicios / 100;
        var ptsFinalesEjercicios = divEjercico * ptsEjercicio;

        var divExamenes = sumaCalifExamen / unicos[i].num_examenes;
        var ptsExamenes = unicos[i].valor_examenes / 100;
        var ptsFinalesExamenes = divExamenes * ptsExamenes;

        cantAsistencia = sumaAsistencia + sumaRetardo;

        // Puntos de los ejercicios
        var ejerciciosFaltante = unicos[i].num_ejercicios - cantEjercicio;
        var ptsDispoEjercicio =
          ejerciciosFaltante *
          (unicos[i].valor_ejercicios / unicos[i].num_ejercicios);

        // Pts de los examenes
        var examenesFaltante = unicos[i].num_examenes - cantExamen;
        var ptsDispoExamen =
          examenesFaltante *
          (unicos[i].valor_examenes / unicos[i].num_examenes);

        // Puntos de las asistencias
        var asistenciasFaltante =
          unicos[i].total_dias_laborales - cantAsistencia;
        var ptsDispoAsis =
          asistenciasFaltante *
          (unicos[i].valor_asistencia / unicos[i].total_dias_laborales);

        // Puntos finales
        var ptsDispoFinales = ptsDispoEjercicio + ptsDispoExamen + ptsDispoAsis;

        var payload = {
          nombre: unicos[i].nombre,
          matricula: unicos[i].matricula,
          grupo: unicos[i].grupo,
          examenes: cantExamen,
          num_examenes: unicos[i].num_examenes,
          ejercicios: cantEjercicio,
          num_ejercicios: unicos[i].num_ejercicios,
          total: (
            ptsFinalesEjercicios +
            ptsFinalesExamenes +
            sumaTotalAsistencia
          ).toFixed(2),
          asistencias: cantAsistencia,
          total_dias_laborales: unicos[i].total_dias_laborales,
          pts_finales: ptsDispoFinales.toFixed(2),
          telefono: unicos[i].telefono,
          celular: unicos[i].celular,
          extra: califExtra,
          ptsDispoEjercicio: ptsFinalesEjercicios,
          ptsDispoExamen: ptsFinalesExamenes,
          ptsDispoAsis: sumaTotalAsistencia,
          teacher: "",
          teacher2: "",
          primera: unicos[i].calificacion_final_primera_oportunidad,
          segunda: unicos[i].calificacion_final_segunda_oportunidad,
          id_curso: unicos[i].id_curso,
          id_grupo: unicos[i].id_grupo,
          id_nivel: unicos[i].id_nivel,
          id_alumno: unicos[i].id_alumno,
          escuela: this.escuela,
          estado_comentario: unicos[i].estado_comentario,
          pases_extra: unicos[i].pases_extra
        };

        this.alumnos.push(payload);
      }
      this.cargar = false;
    },

    // EXCEL
    exportar() {
      let xls = {
        data: this.alumnos,
        tHeaders: ["Codigo", "Nombre", "Sal", "Labortorio"],
        filterVal: ["codigo", "nomart", "sal", "lab"],
        nomfile: "Productos",
      };
      this.exportExcel();
    },

    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    exportExcel() {
      let data = XLSX.utils.json_to_sheet(this.alumnos);
      const workbook = XLSX.utils.book_new();
      const filename = "puntos_dispo_fast";
      XLSX.utils.book_append_sheet(workbook, data, filename);

      var wbout = XLSX.write(workbook, {
        bookType: "xls",
        bookSST: false,
        type: "binary",
      });

      const file = new File([new Blob([this.s2ab(wbout)])], filename + ".xls");
      console.log(file);

      let formData = new FormData();
      // //se crea el objeto y se le agrega como un apendice el archivo
      formData.append("file", file);
      // /*Initialize the form data*/

      this.$http
        .post("pdfs", formData)
        .then((response) => {
          window.location =
            axios.defaults.baseURL + "pdfs/" + filename + ".xls";
        })
        .catch((error) => {
          alert(error.body);
          console.log(error);
        });
    },

    confirmarCargaMasiva() {
      const calificaciones = this.filterAlumnos;

      if (!calificaciones.length) {
        this.validarError('No hay alumnos para cargar con los filtros actuales');
        return;
      }

      const alumnosCerti = calificaciones.filter((item) => item.grupo && item.grupo.match('CERTI')).length;
      const alumnosSinKardex = calificaciones.filter((item) => !item.primera && (item.total >= 69 || item.extra >= 70)).length;

      this.$swal({
        title: 'Confirmar carga masiva',
        html: `
          <div style="text-align:left">
            <p>Se cargarán <b>${calificaciones.length}</b> alumnos visibles con los filtros actuales.</p>
            <p><b>${alumnosSinKardex}</b> alumnos cumplen con filtro de sin kardex/aprobados.</p>
            <p><b>${alumnosCerti}</b> alumnos de certificación serán omitidos por la regla actual.</p>
          </div>
        `,
        icon: 'warning',
        input: 'checkbox',
        inputPlaceholder: 'Solicitar notificación automática a alumnos al finalizar',
        showCancelButton: true,
        confirmButtonText: 'Sí, cargar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.subirCalifiaciones({
            notificarAlumnos: Boolean(result.value)
          });
        }
      });
    },

    subirCalifiaciones(opciones = {}) {
      this.cargar = true;

      let calificaciones = this.filterAlumnos

      const payload = {
        escuela: this.escuela,
        calificaciones,
        notificarAlumnos: Boolean(opciones.notificarAlumnos)
      };

      this.$http
        .post("subir.calificaciones", payload)
        .then((response) => {
          const { message, resumen } = response.data;
          let mensaje = message;

          if (resumen) {
            mensaje = `${message}
Procesadas: ${resumen.procesadas}
Actualizadas: ${resumen.actualizadas}
Nuevas: ${resumen.creadas}
Omitidas: ${resumen.omitidas}`;

            if (resumen.notificaciones && resumen.notificaciones.solicitadas) {
              mensaje += `
Notificaciones: ${resumen.notificaciones.mensaje}`;
            }
          }

          this.validarSuccess(mensaje);

          this.consultarCalificaciones({ force: true });
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    activarExamenReubicacion(item) {
      this.$swal({
        title: 'Activar examen de reubicación',
        html: `Se ajustará la calificación de <b>${item.nombre}</b> (${item.matricula}) a <b>60</b> en el kardex.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, activar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.cargar = true;
        const payload = {
          escuela: this.escuela,
          id_curso: item.id_curso,
          id_alumno: item.id_alumno,
          id_grupo: item.id_grupo,
          id_nivel: item.id_nivel,
          grupo: item.grupo,
          iderp: this.getdatosUsuarioERPERP.iderp
        };

        this.$http
          .post('activar.examen.reubicacion', payload)
          .then((response) => {
            this.validarSuccess(response.data.message);
            this.consultarCalificaciones({ force: true });
          })
          .catch((error) => {
            this.validarError(error);
          })
          .finally(() => {
            this.cargar = false;
          });
      });
    },

    subirCalifiacionAlumno(item) {
      this.cargar = true;
      const payload = {
        escuela: this.escuela,
        id_curso: item.id_curso,
        id_alumno: item.id_alumno,
        id_grupo: item.id_grupo,
        id_nivel: item.id_nivel,
        primera: item.primera,
        segunda: item.segunda,
        total: item.total,
        extra: item.extra,
        pases_extra: item.pases_extra,
        grupo: item.grupo,
        estado_comentario: item.estado_comentario
      };
       this.$http
         .post("subir.calificacionAlumno", payload)
         .then((response) => {
           this.validarSuccess(response.data.message);

           this.consultarCalificaciones({ force: true });
         })
         .catch((error) => {
           this.validarError(error);
         })
         .finally(() => {
           this.cargar = false;
         });
    },

    buscarCalificacion(alumno) {
      this.cargar = true;
      // Hacemos la peticios
      this.$http
      .post(`calificaciones.alumno`, alumno)
      .then((response) => {

          console.log('calificaciones')
          console.log( response.data )

          this.calificaciones = response.data;

          const califAsistencias = this.calificaciones.asistencias.pts_total_asistencia;
          const califAsistenciasL = this.calificaciones.asistencias.limite;
          const califEjercicios = this.calificaciones.ejercicios.pts_total_ejercicios;
          const califEjerciciosL = this.calificaciones.ejercicios.limite;
          const califExamenes = this.calificaciones.examenes.pts_total_examenes;
          const califExamenesL = this.calificaciones.examenes.limite;
          const calificacion_total = this.calificaciones.calificacion_total;

          this.verCalificaciones = true;
          this.dialogAlumno = true;
          this.cargar = false;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },

    async abrirDialog(id_evaluacion, id_alumno, id_grupo, item) {

      this.dialogPreview.status = true

      await this.$refs.previewLeccion.initialize( id_evaluacion, id_alumno, id_grupo, this.escuela, item )
    },

    eliminarEjercicio(id_evaluacion, id_alumno, id_grupo, ejercicio, tipoRecurso = 'ejercicio') {

      this.$swal(
        {
          title: '¿Estás seguro?',
          text: `Vas a eliminar el ${ tipoRecurso } ${ ejercicio.session }. Esta acción no se puede deshacer.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, eliminar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {

          if (result.isConfirmed) {
            const payload = {
              id_evaluacion: id_evaluacion,
              id_usuario: id_alumno,
              id_grupo: id_grupo,
              escuela: this.escuela
            };

            this.disabled = true;
            this.loading  = true;
            this.cargar   = true;

            const indexEjercicio = this.calificaciones.ejercicios.desgloce.findIndex(
              e => e.id_evaluacion === id_evaluacion && e.id_alumno === id_alumno && e.id_grupo === id_grupo
            );

            const indexExamen = this.calificaciones.examenes.desgloce.findIndex(
              e => e.id_evaluacion === id_evaluacion && e.id_alumno === id_alumno && e.id_grupo === id_grupo
            );

            this.$http.post('delete.recurso.contestar', payload)
            .then(response => {
              console.log('Recurso eliminado:', response);

              if (indexEjercicio !== -1) {
                this.calificaciones.ejercicios.desgloce.splice(indexEjercicio, 1);
              }

              if (indexExamen !== -1) {
                this.calificaciones.examenes.desgloce.splice(indexExamen, 1);
              }

              if (this.calificaciones.grupo) {
                this.buscarCalificacion({
                  id_alumno,
                  id_grupo,
                  id_nivel: this.calificaciones.grupo.id_nivel,
                  id_curso: this.calificaciones.grupo.id_curso,
                  escuela: this.escuela,
                });
              }

              this.consultarCalificaciones({ force: true });
              this.$swal('Eliminado', `El ${tipoRecurso} fue eliminado correctamente.`, 'success');
            })
            .catch(error => {
              console.log(error);
              this.validarErrores(error);
              this.$swal('Error', `No se pudo eliminar el ${tipoRecurso}.`, 'error');
            })
            .finally(() => {
              this.disabled = false;
              this.loading  = false;
              this.cargar   = false;
            });
          }
        });
    },

    editarAsistencia(item) {
  this.asistenciaSeleccionada = { ...item };
  this.nuevoValorAsistencia = item.valor_asistencia;
  this.dialogEditarAsistencia = true;
},

cerrarDialogEditar() {
  this.dialogEditarAsistencia = false;
  this.asistenciaSeleccionada = {};
  this.nuevoValorAsistencia = null;
},

guardarAsistencia() {
  if (this.nuevoValorAsistencia === null) {
    this.validarError({ response: { data: { message: 'Por favor selecciona un valor' } } });
    return;
  }

  this.guardandoAsistencia = true;
  
  const payload = {
    id: this.asistenciaSeleccionada.id,
    valor_asistencia: this.nuevoValorAsistencia
  };

  this.$http
    .post('actualizar.asistencia', payload)
    .then((response) => {
      this.validarSuccess(response.data.message || 'Asistencia actualizada correctamente');
      
      // Actualizar el valor en el arreglo local
      const index = this.calificaciones.asistencias.desgloce.findIndex(
        a => a.id === this.asistenciaSeleccionada.id
      );
      
      if (index !== -1) {
        // Actualizar el objeto local con el nuevo valor
        this.calificaciones.asistencias.desgloce[index].valor_asistencia = this.nuevoValorAsistencia;
        
        // Actualizar el texto y color según el nuevo valor
        // Puedes ajustar esto según la lógica de tu backend
        const valorTextMap = {
          0: { text: 'Pendiente', color: 'gray' },
          1: { text: 'Con participación', color: 'success' },
          2: { text: 'Sin participación', color: 'error' },
          
        };
        
        const nuevoValor = valorTextMap[this.nuevoValorAsistencia] || { text: 'Desconocido', color: 'grey' };
        this.calificaciones.asistencias.desgloce[index].valor_text = nuevoValor.text;
        this.calificaciones.asistencias.desgloce[index].color = nuevoValor.color;
      }
      
      // Recargar las calificaciones para asegurar sincronización
      // this.buscarCalificacion(/* pasar el alumno actual */);
      
      this.cerrarDialogEditar();
    })
    .catch((error) => {
      this.validarError(error);
    })
    .finally(() => {
      this.guardandoAsistencia = false;
    });
},

editarAsistencia(item) {
  this.asistenciaSeleccionada = { ...item };
  this.nuevoValorAsistencia = item.valor_asistencia;
  this.dialogEditarAsistencia = true;
},

cerrarDialogEditar() {
  this.dialogEditarAsistencia = false;
  this.asistenciaSeleccionada = {};
  this.nuevoValorAsistencia = null;
},

guardarAsistencia() {
  if (this.nuevoValorAsistencia === null) {
    this.validarError({ response: { data: { message: 'Por favor selecciona un valor' } } });
    return;
  }

  this.guardandoAsistencia = true;
  
  const payload = {
    id: this.asistenciaSeleccionada.id,
    id_usuario: this.asistenciaSeleccionada.id_usuario,
    valor_asistencia: this.nuevoValorAsistencia
  };

  this.$http
    .post('actualizar.asistencia', payload)
    .then((response) => {
      this.validarSuccess(response.data.message || 'Asistencia actualizada correctamente');
      
      // Actualizar el valor en el arreglo local
      const index = this.calificaciones.asistencias.desgloce.findIndex(
        a => a.id === this.asistenciaSeleccionada.id
      );
      
      if (index !== -1) {
        // Actualizar el objeto local con el nuevo valor
        this.calificaciones.asistencias.desgloce[index].valor_asistencia = this.nuevoValorAsistencia;
        
        // Actualizar el texto y color según el nuevo valor
        // Puedes ajustar esto según la lógica de tu backend
        const valorTextMap = {
          0: { text: 'Asistencia', color: 'gray' },
          1: { text: 'Con participación', color: 'success' },
          2: { text: 'Sin participación', color: 'error' },
          
        };
        
        const nuevoValor = valorTextMap[this.nuevoValorAsistencia] || { text: 'Desconocido', color: 'info' };
        this.calificaciones.asistencias.desgloce[index].valor_text = nuevoValor.text;
        this.calificaciones.asistencias.desgloce[index].color = nuevoValor.color;
      }
      
      // Recargar las calificaciones para asegurar sincronización
      // this.buscarCalificacion(/* pasar el alumno actual */);
      
      this.cerrarDialogEditar();
    })
    .catch((error) => {
      this.validarError(error);
    })
    .finally(() => {
      this.guardandoAsistencia = false;
    });
},

onClickRow(item) {
  console.log(this.getdatosUsuarioERPERP.idpuesto )    
  if (![11, 12].includes(this.getdatosUsuarioERPERP.idpuesto)) return;
    this.editarAsistencia(item);
  },

  },
};
</script>

<style scoped>
.puntos-alumnos-acciones {
  gap: 2px;
  min-width: 88px;
}

.puntos-alumnos-acciones--con-reubicacion {
  min-width: 124px;
}

::v-deep .puntos-alumnos-tabla th:last-child,
::v-deep .puntos-alumnos-tabla td:last-child {
  white-space: nowrap;
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 1;
  box-shadow: -4px 0 8px -4px rgba(0, 0, 0, 0.1);
}

::v-deep .puntos-alumnos-tabla thead th:last-child {
  z-index: 3;
}

::v-deep .puntos-alumnos-tabla tbody tr:hover td:last-child {
  background: #f5f5f5;
}
</style>
